import { render, staticRenderFns } from "./ConnectWithSocial.vue?vue&type=template&id=bc5c8ba0"
import script from "./ConnectWithSocial.vue?vue&type=script&lang=js"
export * from "./ConnectWithSocial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports